module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.type == 'sticker' && _vm.aucdates && _vm.item.auction_order_number) ? _c('div', {
    staticClass: "sticker",
    class: {
      pop: _vm.loading
    },
    on: {
      "click": _vm.loadLabel
    }
  }, [_c('div', {
    staticClass: "barc"
  }, [_c('img', {
    staticClass: "odboom",
    attrs: {
      "src": "/static/img/odblogo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sticker-head"
  }, [_c('span', {
    staticClass: "aucdates"
  }, [_vm._v(_vm._s(_vm.parseAucDates(_vm.aucdates)))])]), _vm._v(" "), _c('div', {
    staticClass: "desc lot"
  }, [_vm._v("lot")]), _vm._v(" "), _c('div', {
    staticClass: "desc ib"
  }, [_vm._v("ib")]), _vm._v(" "), _c('div', {
    staticClass: "lotnr"
  }, [_vm._v(_vm._s(_vm.item.auction_order_number))]), _vm._v(" "), _c('div', {
    staticClass: "ibcode"
  }, [_vm._v(_vm._s(_vm.item.seller.code) + "-" + _vm._s(_vm.item.number))]), _vm._v(" "), _c('barcode', {
    staticClass: "bar",
    attrs: {
      "width": 1.2,
      "height": 26,
      "margin": 0,
      "value": _vm.createBarcode(_vm.item),
      "displayValue": false
    }
  }, [_vm._v("\n\t\t\t    Barcode niet gegenereerd!\n\t\t\t")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.type == 'icon') ? _c('button', {
    class: {
      pop: _vm.loading, dis: !_vm.aucdates || !_vm.item.auction_order_number
    },
    attrs: {
      "disabled": !_vm.aucdates || !_vm.item.auction_order_number,
      "title": "Print DYMO label"
    },
    on: {
      "click": _vm.loadLabel
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-barcode"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9fe55074"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/ODBBarcode.vue
// module id = 1332
// module chunks = 1